import { ExcelExportParameters } from '@scts/models';

export const hearingsExcelExportParams: ExcelExportParameters = {
  tableHeaders: [
    "Hearing Date And Time",
    "Hearing Type",	
    "Venue",	
    "Reference",	
    "Appeal Type",	
    "Appeal Subtype",	
    "Appellant",	
    "Representative",	
    "Respondent",	
    "Address",	
    "Assessor Reference",	
    "Property Type",	
    "Net Annual Value",	
    "Rateable Value",	
    "Effective Date",	
    "Appeal Date",	
    "Appeal Reason",
    "Valuation Roll Reference",
  ],
  typeOfData: "hearings",
  tableColumnsWidth: [22, 16, 52, 22, 22, 16, 16, 22, 22, 30, 22, 16, 16, 16, 16, 16, 30, 22],
}